import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';

import { Button } from '.';

import { useStateContext } from '../contexts/ContextProvider';

const Notification = () => {
  const { currentColor, isClicked, setIsClicked } = useStateContext();

  return (
    <div className="nav-item absolute right-5 md:right-40 top-16 bg-white dark:bg-[#42464D] p-8 rounded-lg w-96">
      <div className="flex justify-between items-center">
        <div className="flex gap-3">
          <p className="font-semibold text-lg dark:text-gray-200">Notificaciones</p>
          <button type="button" className="text-white text-xs rounded p-1 px-2 bg-orange-theme "> 5 Nuevas</button>
        </div>
        <button
            type="button"
            onClick={ () => { setIsClicked( !isClicked.notification )} }
            style={{ color: 'rgb(153, 171, 180)', borderRadius: '50%' }}
            className="text-2xl p-3 hover:drop-shadow-xl hover:bg-light-gray"
          >
          <MdOutlineCancel />
        </button>
      </div>
      <div className="mt-5 ">
   
        <div className="mt-5">
          <Button color="white" bgColor={currentColor} text="Ver Todas las Notificaciones" borderRadius="10px" width="full" />
        </div>
      </div>
    </div>
  );
};

export default Notification;